import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LegalPages.css';

const TermsOfService = () => {
  const { t, i18n } = useTranslation('legal');
  const currentLang = i18n.language;
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="landing-page__header">
        <div className="landing-page__logo-container">
          <Link to={currentLang === 'fr' ? '/fr' : '/'}>
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="AIvatar Logo" className="landing-page__logo" />
          </Link>
        </div>
      </header>
      
      <main className="legal-page__content container">
        <h1>{t('terms.title')}</h1>
        
        <section className="legal-page__section">
          <h2>{t('terms.general.title')}</h2>
          <p><strong>{t('company.name')}</strong>: BOCO<br />
          <strong>{t('company.rcs')}</strong>: 895311082<br />
          <strong>{t('company.status')}</strong>: {t('company.status_value')}<br />
          <strong>{t('company.siret')}</strong>: 89531108200021<br />
          <strong>{t('company.address')}</strong>: Les Catalas, 09700 Saverdun France<br />
          <strong>{t('company.phone')}</strong>: 0756835116<br />
          <strong>{t('company.email')}</strong>: contact@muware.xyz<br />
          <strong>{t('company.manager')}</strong>: contact@muware.xyz</p>
          
          <p>{t('terms.general.description')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.service.title')}</h2>
          <p>{t('terms.service.description')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.accounts.title')}</h2>
          <p>{t('terms.accounts.p1')}</p>
          <p>{t('terms.accounts.p2')}</p>
          <p>{t('terms.accounts.p3')}</p>
          <p>{t('terms.accounts.p4')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.content.title')}</h2>
          <p>{t('terms.content.p1')}</p>
          <p>{t('terms.content.p2')}</p>
          <ul>
            <li>{t('terms.content.list.item1')}</li>
            <li>{t('terms.content.list.item2')}</li>
            <li>{t('terms.content.list.item3')}</li>
            <li>{t('terms.content.list.item4')}</li>
            <li>{t('terms.content.list.item5')}</li>
            <li>{t('terms.content.list.item6')}</li>
          </ul>
          <p>{t('terms.content.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.data.title')}</h2>
          <p>{t('terms.data.p1')}</p>
          <p>{t('terms.data.p2')}</p>
          <p>{t('terms.data.p3', { privacyLink: currentLang === 'fr' ? '/fr/privacy-policy' : '/privacy-policy' })}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.payment.title')}</h2>
          <p>{t('terms.payment.p1')}</p>
          <p>{t('terms.payment.p2')}</p>
          <p>{t('terms.payment.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.refund.title')}</h2>
          <p>{t('terms.refund.p1')}</p>
          <p>{t('terms.refund.p2')}</p>
          <ul>
            <li>{t('terms.refund.list.item1')}</li>
            <li>{t('terms.refund.list.item2')}</li>
          </ul>
          <p>{t('terms.refund.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.ip.title')}</h2>
          <p>{t('terms.ip.p1')}</p>
          <p>{t('terms.ip.p2')}</p>
          <p>{t('terms.ip.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.disclaimer.title')}</h2>
          <p>{t('terms.disclaimer.p1')}</p>
          <p>{t('terms.disclaimer.p2')}</p>
          <p>{t('terms.disclaimer.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.limitation.title')}</h2>
          <p>{t('terms.limitation.p1')}</p>
          <p>{t('terms.limitation.p2')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.indemnification.title')}</h2>
          <p>{t('terms.indemnification.p1')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.termination.title')}</h2>
          <p>{t('terms.termination.p1')}</p>
          <p>{t('terms.termination.p2')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.changes.title')}</h2>
          <p>{t('terms.changes.p1')}</p>
          <p>{t('terms.changes.p2')}</p>
          <p>{t('terms.changes.p3')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.governing.title')}</h2>
          <p>{t('terms.governing.p1')}</p>
          <p>{t('terms.governing.p2')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.hosting.title')}</h2>
          <p>{t('terms.hosting.p1')}<br />
          OVH SAS<br />
          2 rue Kellermann<br />
          59100 Roubaix - France</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('terms.contact.title')}</h2>
          <p>{t('terms.contact.p1')}<br />
          contact@muware.xyz</p>
        </section>
        
        <p className="legal-page__last-updated">{t('lastUpdated')}: {t('dateUpdated')}</p>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>© 2025 AIvatar. {t('footer.rights')}</p>
          <div className="footer-links">
            <Link to={currentLang === 'fr' ? '/fr/terms-of-service' : '/terms-of-service'}>{t('footer.terms')}</Link>
            <Link to={currentLang === 'fr' ? '/fr/privacy-policy' : '/privacy-policy'}>{t('footer.privacy')}</Link>
            <a href="mailto:contact@muware.xyz">{t('footer.contact')}</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService; 